import { setIn } from "final-form";
import constants from "safervpn-storybook/src/data/constants.json";
import * as actions from "./networkPoliciesGetActions";
import { NETWORK_POLICY_GET_REQUEST_SUCCESS } from "store/api/organization/networkPolicyGet/networkPolicyGetActions";
import { NETWORK_POLICIES_POST_REQUEST_SUCCESS } from "store/api/organization/networkPoliciesPost/networkPoliciesPostActions";
import { NETWORK_POLICY_ROLLBACK_PUT_REQUEST_SUCCESS } from "store/api/organization/networkPolicyRollbackPut/networkPolicyRollbackPutActions";
import {
  SOCKET_EVENT_NETFILTER_UPDATE_SUCCESS,
  SOCKET_EVENT_NETFILTER_UPDATE_FAILED,
  SOCKET_EVENT_NETFILTER_ROLLBACK_SUCCESS,
  SOCKET_EVENT_ENABLE_FIREWALL_LOGS_SUCCESS
} from "store/api/organization/networksBeaconsGet/networksBeaconsGetActions";

let { FAILED } = constants.networkBeaconStatus;

function maybeRestoreDeletedRules(networkPolicy) {
  if (networkPolicy.status === FAILED) {
    let ruleIds = networkPolicy.networkPolicyRules.map((rule) => rule.id);
    let deletedRules = networkPolicy.prevSuccessState?.networkPolicyRules.filter(
      (rule) => !ruleIds.includes(rule.id)
    );
    if (deletedRules?.length > 0) {
      networkPolicy = {
        ...networkPolicy,
        networkPolicyRules: networkPolicy.networkPolicyRules.concat(
          deletedRules.map((rule) => ({ ...rule, status: "deleted" }))
        ),
      };
    }
  }
  extractServices(networkPolicy);
  return networkPolicy;
}

function extractServices(networkPolicy) {
  let { networkPolicyRules, prevSuccessState } = networkPolicy;
  for (let rule of networkPolicyRules) {
    let { services, destinations } = rule.destinations.reduce(
      (map, item) => {
        if (item.type === "service") {
          map.services.push(item);
        } else {
          map.destinations.push(item);
        }
        return map;
      },
      {
        services: [],
        destinations: [],
      }
    );
    rule.destinations = destinations;
    rule.services = services;
  }
  if (prevSuccessState) {
    extractServices(prevSuccessState);
  }
}

function replaceNetworkPolicy(state, index, networkPolicy) {
  extractServices(networkPolicy);
  return setIn(state, `data.networkPolicies[${index}]`, networkPolicy);
}

function updatePolicyFromBeacon(state, action) {
  let {
    networkPolicy,
    networkPolicy: { id },
  } = action.data.networkBeacon.data;
  let policyIndex = state.data.networkPolicies.findIndex((p) => p.id === id);
  return setIn(
    state,
    `data.networkPolicies[${policyIndex}]`,
    maybeRestoreDeletedRules(networkPolicy)
  );
}

function updateTraceFromBeacon(state, action) {
  const {
    network: { id, attributes: { netFilter: { attributes: { trace } } } },
  } = action.data.networkBeacon.data;
  const policyIndex = state.data.networkPolicies.findIndex((p) => p.network === id);

  return setIn(
    state,
    `data.networkPolicies[${policyIndex}]`,
    { ...state.data.networkPolicies[policyIndex], trace }
  );
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [actions.NETWORK_POLICIES_GET_REQUEST]: (state, action) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
    data: state.data,
  }),
  [actions.NETWORK_POLICIES_GET_REQUEST_SUCCESS]: (state, action) => {
    return {
      ...state,
      loading: false,
      loaded: true,
      error: null,
      data: {
        networkPolicies: action.data.networkPolicies.map(
          maybeRestoreDeletedRules
        ),
        relationships: action.data.relationships,
      },
    };
  },
  [actions.NETWORK_POLICIES_GET_REQUEST_FAILURE]: (state, action) => ({
    ...state,
    loading: false,
    loaded: false,
    error: action.error,
    data: null,
  }),
  [NETWORK_POLICIES_POST_REQUEST_SUCCESS]: (state, action) => {
    if (!action.data.networkBeacon) return state;
    let { networkPolicy } = action.data.networkBeacon.data;
    let policyIndex = state.data.networkPolicies.findIndex(
      (p) => p.id === networkPolicy.id
    );
    return replaceNetworkPolicy(state, policyIndex, networkPolicy);
  },
  [NETWORK_POLICY_ROLLBACK_PUT_REQUEST_SUCCESS]: (state, action) => {
    if (!action.data.networkBeacon) return state;
    let { networkPolicy } = action.data.networkBeacon.data;
    let policyIndex = state.data.networkPolicies.findIndex(
      (p) => p.id === networkPolicy.id
    );

    return replaceNetworkPolicy(state, policyIndex, networkPolicy);
  },
  [NETWORK_POLICY_GET_REQUEST_SUCCESS]: (state, action) => {
    let {
      id,
      data: { networkPolicy },
    } = action;
    let policyIndex = state.data.networkPolicies.findIndex((p) => p.id === id);

    return replaceNetworkPolicy(state, policyIndex, networkPolicy);
  },
  [SOCKET_EVENT_NETFILTER_UPDATE_SUCCESS]: updatePolicyFromBeacon,
  [SOCKET_EVENT_NETFILTER_UPDATE_FAILED]: updatePolicyFromBeacon,
  [SOCKET_EVENT_NETFILTER_ROLLBACK_SUCCESS]: updatePolicyFromBeacon,
  [SOCKET_EVENT_ENABLE_FIREWALL_LOGS_SUCCESS]: updateTraceFromBeacon,
  [actions.NETWORK_POLICIES_GET_RESET]: (state, action) => initialState,
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  loaded: false,
  loading: false,
  error: null,
  data: null,
};

export default function networkPoliciesGetReducer(
  state = initialState,
  action
) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
